import config from "./../config";
import core from "./../core";
import { map, groupBy, concat, find, findLast, filter } from "lodash";
const app = {};
app.isSetWebview = function () {
  let cookieWEBVIEW = window.source === config.WEBVIEW_KEY;
  if (cookieWEBVIEW) {
    config.IS_WEBVIEW = true;
  } else {
    config.IS_WEBVIEW = false;
  }

  return config.IS_WEBVIEW;
};

app.isTourEnded = (userCurrentTime, endGameDate) => {
  const currentDate = new Date(userCurrentTime);
  const serverEndDate = new Date(endGameDate);
  const objDiff = core.daysBetween(currentDate, serverEndDate);
  const isEOT = objDiff.ms_Diff <= 0 ? true : false;
  return isEOT;
};

app.disableDocumentEvents = () => {
  document.addEventListener("contextmenu", (event) => event.preventDefault());
  document.onkeydown = function (event) {
    event = event || window.event;
    if (
      (event.which === 73 && event.ctrlKey && event.shiftKey) ||
      event.keyCode === 123
    ) {
      return false;
    }
  };
  document.body.setAttribute("unselectable", "on");
  document.body.style.webkitUserSelect = "none";
  document.body.style.userSelect = "none";
  document.body.style.msUserSelect = "none";
  window.addEventListener("selectstart", function (e) {
    e.preventDefault();
  });
};

app.resetBracket = (arrContraintsDefault) => {
  let arrContraints = [];
  for (let i = 0; i < arrContraintsDefault.length; i++) {
    let objStage = arrContraintsDefault[i];
    const { name, subStage } = objStage.stage;
    let arrSubstage = [];
    for (let j = 0; j < (subStage || []).length; j++) {
      let objSubStage = subStage[j];
      const { team, teamSelection } = objSubStage;
      let arrTeamSelection = [];
      let arrTeam = [];
      for (let jN = 0; jN < (team || []).length; jN++) {
        let objTeam = team[jN];
        arrTeam.push({ ...objTeam });
      }
      if (name === config.enumStage.teamSelection) {
        for (let jN = 0; jN < (teamSelection || []).length; jN++) {
          let objTeam = teamSelection[jN];
          arrTeamSelection.push({ ...objTeam });
        }
      }
      let pushSbstage = { ...objSubStage, team: arrTeam };
      if (arrTeamSelection.length) {
        pushSbstage.teamSelection = arrTeamSelection;
      }
      arrSubstage.push(pushSbstage);
    }
    arrSubstage = arrSubstage.sort((a, b) => {
      let valueA = a.name;
      let valueB = b.name;

      if (valueA > valueB) {
        return 1;
      }
      if (valueA < valueB) {
        return -1;
      }
      return 0;
    });
    arrContraints.push({
      ...objStage,
      stage: { ...objStage.stage, name: name, subStage: arrSubstage },
    });
  }
  return arrContraints;
};

//======================Tracking======================
app.googleAnalyticsTracking = function (sTitle, sPath) {
  if (window.gtag) {
    window.gtag("config", config.GA_TRACKING_ID, {
      page_title: sTitle,
      page_path: sPath,
    });
  }
};
app.googleAnalyticsEventTracking = function (action, category, opt_label) {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: opt_label,
      send_to: config.GA_TRACKING_ID,
    });
  }
};
app.TrackGoogleAnalyticsEventByObj = function (obj) {
  if (obj) {
    app.googleAnalyticsEventTracking(obj.action, obj.category, obj.label);
  }
};
//======================Tracking======================
app.getLoginCookie = function () {
  let cookie = core.getCookie(config.COOKIE_FANTASY);
  // console.log("cookie :", cookie);
  let returnCookie = null;
  try {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let parsedCookie = JSON.parse(cookie);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }
    return returnCookie;
  } catch (error) {
    if (cookie) {
      cookie = window.decodeURIComponent(cookie);
      let cookieSpecial = cookie.replace(
        /[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g,
        ""
      );
      let parsedCookie = JSON.parse(cookieSpecial);
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }

    return returnCookie;
  }
};

app.postLogin = (data, callback) => {
  let obj = {
    url: config.API_BASE + "services/Session/anonymouslogin",
    data: data,
    method: "post",
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.getLoginCookieStatus = () => {
  let parentCookie = core.getCookie(config.COOKIE_PARENT);
  let fantasyCookie = core.getCookie(config.COOKIE_FANTASY);
  let ret = config.enumLoginCookie.bothNotPresent;
  if (!parentCookie && !fantasyCookie) {
    ret = config.enumLoginCookie.bothNotPresent;
  } else if (parentCookie && fantasyCookie) {
    ret = config.enumLoginCookie.bothPresent;
  } else if (parentCookie && !fantasyCookie) {
    // only Fifa cookie present.
    ret = config.enumLoginCookie.parentPresent;
  } else if (!parentCookie && fantasyCookie) {
    // only Fantasy cookie present.
    ret = config.enumLoginCookie.fantasyPresent;
  }

  return ret;
};

app.eventValidators = (el, cookie) => {
  let resp = true;
  return resp;
};

app.eventValidatorsLoggedInWithBracket = (el, cookie, arrPlayedGamedays) => {
  let resp = false;
  if (
    cookie &&
    !Number(cookie.isAnonymous) &&
    arrPlayedGamedays &&
    arrPlayedGamedays.length
  ) {
    // if (arrPlayedGamedays && arrPlayedGamedays.length && arrPlayedGamedays.indexOf(config.enumGameStage.knockoutStage) > -1) {
    resp = true;
  }
  return resp;
};

app.getTranslations = function (callback) {
  let obj = {
    url: config.TRANSLATION_API + "?langCode=" + config.CURRENT_LANGUAGE,
    method: "get",
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      config.ImgVersion = response.data.Data.Value.ImgVersion;
      config.endGameDate = response.data.Data.Value.endGameDate;
      if (callback) {
        callback(response.data);
        config.trans = response.data.Data.Value;
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.getCountries = (callback) => {
  let obj = {
    url: config.COUNTRIES_API,
    method: "get",
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.getAgeGroups = (callback) => {
  let obj = {
    url: config.AGE_GROUP_API,
    method: "get",
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.registeruser = (payload, callback) => {
  let obj = {
    url: config.REGISTER_USER_API,
    data: payload,
    method: "post",
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.callGamedaysMapping = (callback) => {
  let url = config.GAMEDAY_API;
  let obj = {
    url: url,
    method: "get",
    loader: true,
  };
  return core
    .makeAPICall(obj)
    .then(function (resp) {
      if (callback) {
        callback(resp.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(error.data);
      }
    });
};

app.callQuizAnswers = (gamedayId, callback) => {
  let url = config.ANSWERS_API;
  let obj = {
    url: url,
    method: "get",
    loader: true,
    params: { GamedayId: gamedayId },
  };
  return core
    .makeAPICall(obj)
    .then(function (resp) {
      if (callback) {
        callback(resp.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(error.data);
      }
    });
};

app.normalLogin = (socialId, callback) => {
  let obj = {
    url: config.API_BASE + "quiz/services/Session/login",
    data: "",
    params: { SocialId: socialId },
    method: "post",
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

app.eventValidatorsGameplayLocked = (el, cookie, userEotStatus) => {
  let resp = true;
  if (userEotStatus == config.enumEotScenarios.no_eot) {
    resp = app.eventValidatorsLoggedIn(el, cookie);
  } else {
    resp = false;
  }
  return resp;
};

app.eventValidatorsGameLocked = (el, cookie, userEotStatus) => {
  let resp = true;
  if (userEotStatus == config.enumEotScenarios.no_eot) {
    resp = app.eventValidatorsLoggedIn(el, cookie);
  } else if (
    userEotStatus == config.enumEotScenarios.logged_out_user ||
    userEotStatus == config.enumEotScenarios.logged_in_without_team
  ) {
    resp = false;
  }
  return resp;
};

app.eventValidatorsLocked = (el, cookie, isGameStatus) => {
  let resp = true;
  if (
    !(cookie && Number(cookie.HasTeam)) &&
    isGameStatus !== config.enumGameStatus.open
  ) {
    resp = false;
  }
  return resp;
};
app.eventValidatorsLoggedIn = (el, cookie) => {
  let resp = false;
  if (cookie) {
    resp = true;
  }
  return resp;
};
app.getClientCookie = () => {
  let cookie = app.getCookie(config.clientCookie);
  let returnCookie = null;
  try {
    if (cookie) {
      // let parsedCookie = JSON.parse(cookie);
      let parsedCookie = JSON.parse(decodeURIComponent(cookie));
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }
    return returnCookie;
  } catch (error) {
    if (cookie) {
      let cookieSpecial = cookie.replace(
        /[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g,
        ""
      );
      // let parsedCookie = JSON.parse(cookieSpecial);
      let parsedCookie = JSON.parse(decodeURIComponent(cookieSpecial));
      if (parsedCookie) {
        returnCookie = parsedCookie;
      }
    }

    return returnCookie;
  }
};

app.getCookie = (c_name) => {
  let i,
    x,
    y,
    cookiesArray = document.cookie.split(";");
  for (i = 0; i < cookiesArray.length; i++) {
    x = cookiesArray[i].substr(0, cookiesArray[i].indexOf("="));
    y = cookiesArray[i].substr(cookiesArray[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x === c_name) {
      return y; //window.decodeURIComponent(y);
    }
  }
};
app.deleteAllCookies = (reloadPage) => {
  var cookies = document.cookie.split(";");
  let exDate = new Date();
  exDate.setDate(exDate.getDate() + -1);
  app.deleteAllLocalStorage();
  var sDomain = window.location.hostname;
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      name +
      "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=" +
      sDomain +
      ";path=/";

    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
  }
  //
  //core.removeLocalStorageValue(config.enumCookie.inviteCookie);
  if (reloadPage) {
    window.location.reload();
  }
};

app.deleteAllLocalStorage = () => {
  core.removeLocalStorageValue(config.tempSelectedPlayerCookieName);
  core.removeLocalStorageValue(config.tempTeamGamedayId);
};

app.creteEmptyTeamFormation = (objFormation, trans) => {
  let arrSelectedPlayer = [];
  const jDfCount = objFormation ? objFormation.DEF : 0;
  const jMfCount = objFormation ? objFormation.MID : 0;
  const jFwCount = objFormation ? objFormation.FWD : 0;
  const jGkCount = 1;
  let arrSelectedPlayerMain = {};
  //Forward Row
  for (let j = 0; j < jFwCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.forwards ? trans.forwards : "Forwards",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.forwards,
      jorder: j + 1,
      skillNameShort: (trans && trans.fwd ? trans.fwd : "FWD").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.forwards] = arrSelectedPlayer;
  //MidFielders Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jMfCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.midfielders ? trans.midfielders : "Midfielders",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.midfielders,
      jorder: j + 1,
      skillNameShort: (trans && trans.mid ? trans.mid : "MID").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.midfielders] = arrSelectedPlayer;
  //Defenders Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jDfCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.defenders ? trans.defenders : "Defenders",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.defenders,
      jorder: j + 1,
      skillNameShort: (trans && trans.def ? trans.def : "DEF").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.defenders] = arrSelectedPlayer;
  //GoalKeepers Row
  arrSelectedPlayer = [];
  for (let j = 0; j < jGkCount; j++) {
    let row = {
      id: j + 1,
      name: trans && trans.goalkeepers ? trans.goalkeepers : "Goalkeepers",
      filterIndex: config.emptyValue,
      skill: config.enumPosition.goalkeepers,
      jorder: j + 1,
      skillNameShort: (trans && trans.gk ? trans.gk : "GK").toUpperCase(),
    };
    arrSelectedPlayer.push(row);
  }
  arrSelectedPlayerMain[config.enumPosition.goalkeepers] = arrSelectedPlayer;
  return arrSelectedPlayerMain;
};
app.creatrNewSkillRow = (arrSkillOld, arrSkillNew, jAvoidFiltreIndex) => {
  for (let jN = 0; jN < (arrSkillOld || []).length; jN++) {
    const objRowOld = arrSkillOld[jN];
    for (let jNDex = 0; jNDex < (arrSkillNew || []).length; jNDex++) {
      const objRowNew = arrSkillNew[jNDex];
      if (
        jAvoidFiltreIndex !== objRowOld.filterIndex &&
        objRowNew.filterIndex === config.emptyValue
      ) {
        objRowNew.filterIndex = objRowOld.filterIndex;
        break;
      }
    }
  }
  return arrSkillNew;
};
app.getCurrentSelectedTabIndexes = (
  jSkillP,
  arrSkillFiltreTab,
  arrSelectedPlayer
) => {
  let jSkillFiltreTab = jSkillP;
  let jSkillFiltreTabPlayer = -1;
  loop1: for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
    const objSkill = arrSkillFiltreTab[j];
    const jSkillKey = objSkill.id;
    const arrSelectedPlayerBySkill = arrSelectedPlayer[jSkillKey];
    //
    const arrSkillNew = [];
    const arrSkillNewEmpty = [];
    for (let jN = 0; jN < (arrSelectedPlayerBySkill || []).length; jN++) {
      let objSkill = arrSelectedPlayerBySkill[jN];
      if (objSkill.filterIndex === config.emptyValue) {
        arrSkillNewEmpty.push({ ...objSkill });
      } else {
        arrSkillNew.push({ ...objSkill });
      }
    }
    for (let jN = 0; jN < (arrSkillNewEmpty || []).length; jN++) {
      let objSkill = arrSkillNewEmpty[jN];
      arrSkillNew.push({ ...objSkill });
    }
    //
    for (let jN = 0; jN < (arrSkillNew || []).length; jN++) {
      const objPlayer = arrSkillNew[jN];
      if (objPlayer.filterIndex === config.emptyValue) {
        if (
          (!jSkillFiltreTab && jSkillFiltreTab !== 0) ||
          jSkillFiltreTab <= j
        ) {
          jSkillFiltreTab = j;
          jSkillFiltreTabPlayer = jN;
          break loop1;
        }
      }
    }
  }
  if (jSkillFiltreTabPlayer === -1) {
    loop1: for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
      const objSkill = arrSkillFiltreTab[j];
      const jSkillKey = objSkill.id;
      const arrSelectedPlayerBySkill = arrSelectedPlayer[jSkillKey];
      //
      const arrSkillNew = [];
      const arrSkillNewEmpty = [];
      for (let jN = 0; jN < (arrSelectedPlayerBySkill || []).length; jN++) {
        let objSkill = arrSelectedPlayerBySkill[jN];
        if (objSkill.filterIndex === config.emptyValue) {
          arrSkillNewEmpty.push({ ...objSkill });
        } else {
          arrSkillNew.push({ ...objSkill });
        }
      }
      for (let jN = 0; jN < (arrSkillNewEmpty || []).length; jN++) {
        let objSkill = arrSkillNewEmpty[jN];
        arrSkillNew.push({ ...objSkill });
      }
      //
      for (let jN = 0; jN < (arrSkillNew || []).length; jN++) {
        const objPlayer = arrSkillNew[jN];
        if (objPlayer.filterIndex === config.emptyValue) {
          if (jSkillFiltreTab > j) {
            jSkillFiltreTab = j;
            jSkillFiltreTabPlayer = jN;
            break loop1;
          }
        }
      }
    }
  }
  if (jSkillFiltreTabPlayer === -1) {
    jSkillFiltreTab = config.emptyValue;
    jSkillFiltreTabPlayer = config.emptyValue;
  }
  return {
    jSkillFiltreTab: jSkillFiltreTab,
    jSkillFiltreTabPlayer: jSkillFiltreTabPlayer,
  };
};

app.isPlayerFromSelection = (
  arrSelectedPlayer,
  sKeyToSearch,
  sValueToSearch
) => {
  const jIndexSelectedPlayer = core.getIndexOfArrayByValue(
    arrSelectedPlayer,
    sKeyToSearch,
    sValueToSearch
  );
  const isSelected = jIndexSelectedPlayer === -1 ? false : true;
  return isSelected;
};
app.getPlayerDetailsById = (arrPlayers, jId) => {
  let objPlayer = null;
  if (jId) {
    objPlayer = arrPlayers && arrPlayers.find((ele) => ele.Id === jId);
  }
  return objPlayer;
};
app.breakRefInSelection = (arrSelectedPlayer) => {
  let arrSelectedPlayerMain = {};
  for (let jKey in arrSelectedPlayer) {
    const arrSkill = arrSelectedPlayer[jKey];
    let arrSkillNew = [];
    for (let jN = 0; jN < (arrSkill || []).length; jN++) {
      let objSkill = arrSkill[jN];
      arrSkillNew.push({ ...objSkill });
    }
    arrSelectedPlayerMain[jKey] = arrSkillNew;
  }
  return arrSelectedPlayerMain;
};
app.getFilledCountOfPlayerSelectionBySkill = (arrSelectedPlayer, jSKill) => {
  let jCount = 0;
  const arrSkill = arrSelectedPlayer[jSKill];
  for (let jNDex = 0; jNDex < (arrSkill || []).length; jNDex++) {
    const objRowNew = arrSkill[jNDex];
    if (config.emptyValue !== objRowNew.filterIndex) {
      jCount = jCount + 1;
    }
  }
  return jCount;
};
app.getGenerateImage = function (guid, scenarioCode, callback) {
  let sUrl = config.shreGenerateImage.replace("{{guid}}", guid);
  sUrl = sUrl.replace("{{gamedayid}}", 1);
  let obj = {
    url: sUrl,
    method: "post",
    params: {
      LangCode: config.CURRENT_LANGUAGE,
      phaseId: 1,
      scenario: scenarioCode,
    },
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};
app.getGenerateImageResult = function (formationId, callback) {
  let sUrl = config.shreGenerateImageResult;
  let obj = {
    url: sUrl,
    method: "get",
    params: {
      formationId: formationId,
    },
  };
  return core
    .makeAPICall(obj)
    .then(function (response) {
      if (callback) {
        //console.log(response)
        callback(response.data);
      }
    })
    .catch(function (error) {
      if (callback) {
        callback(false);
      }
    });
};

//
app.getSelectedFixture = (arrFixtures, jFixtures) => {
  let objFixture = null;
  if (arrFixtures && arrFixtures.length) {
    objFixture = arrFixtures[jFixtures];
  }
  return objFixture;
};
app.getSelectedPosition = (arrSkillFiltreTab, jSkillFiltreTab) => {
  let objSkillFiltreTab = null;
  if (arrSkillFiltreTab && arrSkillFiltreTab.length) {
    objSkillFiltreTab = arrSkillFiltreTab[jSkillFiltreTab];
  }
  return objSkillFiltreTab;
};

app.getFixtureStatusByRow = (element) => {
  let sMatchStatus = config.enumFixtureType.isUpcomming;
  if (element.IsLocked == 0 && element.IsCurrent == 0) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isUpcomming;
  } else if (element.IsLocked == 0 && element.IsCurrent == 1) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isOpen;
  } else if (
    element.IsLocked == 1 &&
    /* element.IsLive == 0 && */ element.IsCurrent == 1
  ) {
    // Locked
    sMatchStatus = config.enumFixtureType.isLock; //'fixture-box match-closed';
  } else if (element.IsCurrent == 2 && element.IsLocked == 1) {
    /* else if (
    (element.MhIsLocked == 1 &&
      element.IsLive == 2 &&
      element.MhIsCurrent == 1) ||
    Number(element.MatchStatus) === 3
  ) {
    //Match Ended
    sMatchStatus = config.enumFixtureType.isEnded;
  } */
    /*else if (element.IsLive && element.IsLive == 1) {
    //Live
    sMatchStatus = config.enumFixtureType.isLock; //config.enumFixtureType.isLive;
  } */
    //Match finished
    sMatchStatus = config.enumFixtureType.isFinished;
  } else if (element.IsCurrent == 3 && element.IsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isAbandoned;
  }
  // console.log("IsLocked = ",element.IsLocked," ,IsCurrent = ",element.IsCurrent," ,IsLive = ",element.IsLive);
  return sMatchStatus;
};

app.getFixtureStatusByMatches = (element) => {
  let sMatchStatus = config.enumFixtureType.isUpcomming;
  if (element.MhIsLocked == 0 && element.MhIsCurrent == 0) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isUpcomming;
  }
  //(if gameday is open)
  else if (
    element.IsLocked == 0 &&
    element.IsCurrent == 1 &&
    element.MhIsLocked == 0 &&
    element.MhIsCurrent == 1
  ) {
    // Upcoming
    sMatchStatus = config.enumFixtureType.isOpen;
  } else if (
    element.MhIsLocked == 1 &&
    element.IsLive == 0 &&
    element.MhIsCurrent == 1
  ) {
    // Locked
    sMatchStatus = config.enumFixtureType.isLock; //'fixture-box match-closed';
  } else if (
    (element.MhIsLocked == 1 &&
      element.IsLive == 2 &&
      element.MhIsCurrent == 1) ||
    Number(element.MatchStatus) === 3
  ) {
    //Match Ended
    sMatchStatus = config.enumFixtureType.isEnded;
  } else if (element.IsLive && element.IsLive == 1) {
    //Live
    sMatchStatus = config.enumFixtureType.isLock; //config.enumFixtureType.isLive;
  } else if (element.MhIsCurrent == 2 && element.MhIsLocked == 1) {
    //Match finished
    sMatchStatus = config.enumFixtureType.isFinished;
  } else if (element.MhIsCurrent == 3 && element.MhIsLocked == 1) {
    //Match Abandones
    sMatchStatus = config.enumFixtureType.isAbandoned;
  }
  // console.log("IsLocked = ",element.IsLocked," ,IsCurrent = ",element.IsCurrent," ,IsLive = ",element.IsLive);
  return sMatchStatus;
};

app.getGdForMatchFile = (allFixtures) => {
  let obj = {};
  for (let jFixture = 0; jFixture < allFixtures.length; jFixture++) {
    let rowFixtures = allFixtures[jFixture];
    let matchFileName = rowFixtures.MatchFile;
    let matchGD = rowFixtures.TeamGamedayId;
    if (matchFileName) {
      obj[matchFileName] = matchGD;
    }
  }
  return obj;
};

app.getTourStatus = (finalMatch, ftgdid) => {
  let status = config.enumEotScenarios.no_eot;
  if (finalMatch) {
    let objCookie = app.getLoginCookie();
    let isValidUser = objCookie && objCookie.SocialId;
    let firstGD = ftgdid ? ftgdid : 0;
    let HasTeamForFinal = firstGD && firstGD <= finalMatch.TeamGamedayId;
    let isFinalLive =
      finalMatch.IsFixtureAnnounce ==
      config.isAnnouncedStatus.tour_last_match_live;
    let isFinalEnded =
      finalMatch.IsFixtureAnnounce == config.isAnnouncedStatus.tour_ended;
    if (isFinalLive || isFinalEnded) {
      if (isValidUser) {
        if (HasTeamForFinal) {
          if (isFinalLive) {
            status = config.enumEotScenarios.logged_in_with_live_team;
          } else {
            status = config.enumEotScenarios.logged_in_with_team;
          }
        } else {
          status = config.enumEotScenarios.logged_in_without_team;
        }
      } else {
        status = config.enumEotScenarios.logged_out_user;
      }
    }
  }
  return status;
};

app.generateFixtureArray = (lstFixturesP) => {
  let lstFixtures = lstFixturesP;
  //console.log(lstFixtures);
  let arrRound = [];
  for (let jFixture = 0; jFixture < lstFixtures.length; jFixture++) {
    let rowFixtures = lstFixtures[jFixture];
    // let webMonth = core.dateFormat(rowFixtures.Deadlinedate, 'mmmm');
    // let mobMonth = core.dateFormat(rowFixtures.Deadlinedate, 'mmm');
    // let webDate = core.dateFormat(rowFixtures.Deadlinedate, 'd');
    // let S = /*(dateLabel[webDate] ? dateLabel[webDate] : 'th');//*/core.dateFormat(rowFixtures.DateTime, 'S');
    // let sDate = core.dateFormat(rowFixtures.Deadlinedate, 'dd/mm/yyyy hh:MM TT');
    let jDayNo = rowFixtures.Matchday;
    let TeamGamedayId = rowFixtures.TeamGamedayId
      ? +rowFixtures.TeamGamedayId
      : 0;
    let jRound = core.getIndexOfArrayByValue(
      arrRound,
      "TeamGamedayId",
      TeamGamedayId
    );
    if (jRound === -1) {
      let arrDetails = [{ ...rowFixtures }];
      arrRound.push({
        ...rowFixtures,
        arrDetails: arrDetails,
      });
    } else {
      let arrDetails = arrRound[jRound].arrDetails;
      arrDetails.push({ ...rowFixtures });
    }
  }
  return arrRound;
};
app.getMatchDetailsById = (arrFixtures, jId) => {
  let objMatch = null;
  if (jId) {
    loop1: for (let j = 0; j < (arrFixtures || []).length; j++) {
      let objRow = arrFixtures[j];
      for (let jN = 0; jN < (objRow.arrDetails || []).length; jN++) {
        let ele = objRow.arrDetails[jN];
        if (ele.MatchId === jId) {
          objMatch = ele;
          break loop1;
        }
      }
    }
  }
  return objMatch;
};
app.isPointCalDone = (arrFixture) => {
  let isMatchFinished = false;
  for (let j = 0; j < (arrFixture || []).length; j++) {
    let obj = arrFixture[j];
    if (obj) {
      let sMatchStatus = app.getFixtureStatusByRow(obj);
      if (sMatchStatus === config.enumFixtureType.isFinished) {
        isMatchFinished = true;
        break;
      }
    }
  }
  return isMatchFinished;
};

app.getMyFirstFixture = (arrFixture, ftgid) => {
  let obj = null;
  let firstGD = ftgid ? ftgid : 0;

  let myFirstFix = find(arrFixture || [], (f) => {
    return f.TeamGamedayId == firstGD;
  });

  if (myFirstFix) {
    let status = app.getFixtureStatusByRow(myFirstFix);
    obj = {
      fixture: myFirstFix,
      status: status,
    };
  }

  return obj;
};

app.getRecentFixture = (arrFixture, ftgid, liveOnly) => {
  let obj = null;
  let firstGD = ftgid ? ftgid : 0;

  let filteredFixtures = filter(arrFixture || [], (f) => {
    return f.TeamGamedayId >= firstGD;
  });

  if (filteredFixtures && filteredFixtures.length) {
    let openGamedays = find(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return status == config.enumFixtureType.isOpen;
    });
    if (openGamedays && !liveOnly) {
      let status = app.getFixtureStatusByRow(openGamedays);
      obj = {
        fixture: openGamedays,
        status: status,
      };
    }

    let postGamedays = findLast(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return status == config.enumFixtureType.isFinished;
    });
    if (postGamedays && !liveOnly) {
      let status = app.getFixtureStatusByRow(postGamedays);
      obj = {
        fixture: postGamedays,
        status: status,
      };
    }

    let liveGamedays = findLast(filteredFixtures, (f) => {
      let status = app.getFixtureStatusByRow(f);
      return (
        status == config.enumFixtureType.isLock ||
        status == config.enumFixtureType.isLive ||
        status == config.enumFixtureType.isEnded
      );
    });
    if (liveGamedays) {
      let status = app.getFixtureStatusByRow(liveGamedays);
      obj = {
        fixture: liveGamedays,
        status: status,
      };
    }
  }

  return obj;
};

app.isFoundPlayerFromFilter = (arrFiltresTab, ele, arrFixtures) => {
  let fFound = true;
  let arrFound = [];
  for (let j = 0; j < (arrFiltresTab || []).length; j++) {
    const objRow = arrFiltresTab[j];
    let arrDetails = objRow.arrDetails;
    for (let jN = 0; jN < (arrDetails || []).length; jN++) {
      const objFilter = arrDetails[jN];
      if (objFilter.checked) {
        fFound = false;
        if (objRow.id === config.enumTabsId.teams) {
          if (objFilter.id === ele.TeamId) {
            fFound = true;
            break;
          }
        } else if (objRow.id === config.enumTabsId.matches) {
          const objMatch = app.getMatchDetailsById(arrFixtures, objFilter.id);
          if (objMatch) {
            if (
              objMatch.HomeTeamId === ele.TeamId ||
              objMatch.AwayTeamId === ele.TeamId
            ) {
              fFound = true;
              break;
            }
          }
        } else if (objRow.id === config.enumTabsId.nationality) {
          if (objFilter.id === config.enumNationalityIds.foreign) {
            if (Number(ele.IS_FP)) {
              fFound = true;
              break;
            }
          } else if (objFilter.id === config.enumNationalityIds.indian) {
            if (!Number(ele.IS_FP)) {
              fFound = true;
              break;
            }
          }
        } else if (objRow.id === config.enumTabsId.creditRange) {
          if (
            (objFilter.min === -1 || ele.Value >= objFilter.min) &&
            (objFilter.max === -1 || ele.Value <= objFilter.max)
          ) {
            fFound = true;
            break;
          }
        }
      }
    }
    arrFound.push(fFound);
  }
  for (let j = 0; j < arrFound.length; j++) {
    let row = arrFound[j];
    if (!row) {
      fFound = false;
    }
  }
  return fFound;
};
app.getRenderPlayers = (arrSelectedPlayer) => {
  let objRenderPlayer = {
    [config.enumPosition.wk]: [],
    [config.enumPosition.bat]: [],
    [config.enumPosition.ar]: [],
    [config.enumPosition.bowl]: [],
  };
  for (let j = 0; j < arrSelectedPlayer.length; j++) {
    const objPlayer = arrSelectedPlayer[j];
    const isInSkillRange = config.enumPositionText[objPlayer.SkillId];
    if (isInSkillRange) {
      objRenderPlayer[objPlayer.SkillId].push(objPlayer);
    }
  }
  return objRenderPlayer;
};
app.getPlayerDetails = (arrPlayerListing, Id, arrUserTeamPlayerList) => {
  let arrUserTeamPlayerListT = arrUserTeamPlayerList;
  let arrPlayerListingT = arrPlayerListing;
  if (!arrPlayerListing) {
    arrPlayerListingT = [];
  }
  if (!arrUserTeamPlayerList) {
    arrUserTeamPlayerListT = [];
  }
  const jIndexSelectedPlayer = core.getIndexOfArrayByValue(
    arrPlayerListingT,
    "Id",
    Id
  );
  let objMain = arrPlayerListingT[jIndexSelectedPlayer];
  objMain = objMain ? objMain : {};
  const jIndexTeamPlayer = core.getIndexOfArrayByValue(
    arrUserTeamPlayerListT,
    "id",
    Id
  );
  let objMainTeam = arrUserTeamPlayerListT[jIndexTeamPlayer];
  objMainTeam = objMainTeam ? objMainTeam : {};
  return { ...objMain, ...objMainTeam };
};
app.getSelectedCountBySkill = (arrSelectedPlayerP) => {
  let jWkLength = 0;
  let jBtLength = 0;
  let jBlLength = 0;
  let jArLength = 0;
  let arrSelectedPlayer = arrSelectedPlayerP;
  for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
    let rowPosition = arrSelectedPlayer[j];
    if (rowPosition.Id !== config.emptyValue) {
      if (rowPosition.SkillId === config.enumPosition.wk) {
        jWkLength = jWkLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.bat) {
        jBtLength = jBtLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.bowl) {
        jBlLength = jBlLength + 1;
      } else if (rowPosition.SkillId === config.enumPosition.ar) {
        jArLength = jArLength + 1;
      }
    }
  }

  return {
    jWkCount: jWkLength,
    jBtCount: jBtLength,
    jBlCount: jBlLength,
    jArCount: jArLength,
  };
};
app.getMaxMinValidation = (
  arrSelectedPlayer,
  jSkill,
  jSkillMaxLength,
  jMaxTeamCount
) => {
  let objReturn = {};
  let objCountsSkill = app.getSelectedCountBySkill(arrSelectedPlayer);
  let { jWkCount, jBtCount, jBlCount, jArCount } = objCountsSkill;
  let wkMin = config.enumMinPositionNos[config.enumPosition.wk]; //= 1;
  let batMin = config.enumMinPositionNos[config.enumPosition.bat]; // = 3;
  let bowlMin = config.enumMinPositionNos[config.enumPosition.bowl]; // = 3;
  let arMin = config.enumMinPositionNos[config.enumPosition.ar]; // = 2;
  //MAX
  let jCurrentSkillLength = 0;
  for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
    let rowPlayer = arrSelectedPlayer[j];
    if (rowPlayer.SkillId === jSkill) {
      jCurrentSkillLength = jCurrentSkillLength + 1;
    }
  }
  wkMin = wkMin - jWkCount;
  if (jSkill === config.enumPosition.wk) {
    wkMin = wkMin - 1;
  }
  wkMin = wkMin < 0 ? 0 : wkMin;
  batMin = batMin - jBtCount;
  if (jSkill === config.enumPosition.bat) {
    batMin = batMin - 1;
  }
  batMin = batMin < 0 ? 0 : batMin;
  bowlMin = bowlMin - jBlCount;
  if (jSkill === config.enumPosition.bowl) {
    bowlMin = bowlMin - 1;
  }
  bowlMin = bowlMin < 0 ? 0 : bowlMin;
  arMin = arMin - jArCount;
  if (jSkill === config.enumPosition.ar) {
    arMin = arMin - 1;
  }
  arMin = arMin < 0 ? 0 : arMin;
  let jAvailableSkillPlace = wkMin + batMin + bowlMin + arMin;
  objReturn = { wkMin: wkMin, batMin: batMin, bowlMin: bowlMin, arMin: arMin };
  if (jSkillMaxLength <= jCurrentSkillLength) {
    objReturn = { ...objReturn, retVal: config.enumMinMaxType.max };
  }
  //check for minimum positions.
  else if (jMaxTeamCount - 1 < jAvailableSkillPlace) {
    objReturn = { ...objReturn, retVal: config.enumMinMaxType.min };
  }
  return objReturn;
};
app.addInTeamSelection = (
  arrSelectedPlayer,
  jPlayerId,
  jSkill,
  jMaxTeamCountT,
  isCaptain,
  isViceCaptain
) => {
  let flag = false;
  let objCountsSkill = app.getSelectedCountBySkill(arrSelectedPlayer);
  let { jWkCount, jBtCount, jBlCount, jArCount } = objCountsSkill;
  let wkMin = config.enumMinPositionNos[config.enumPosition.wk]; //= 1;
  let batMin = config.enumMinPositionNos[config.enumPosition.bat]; // = 3;
  let bowlMin = config.enumMinPositionNos[config.enumPosition.bowl]; // = 3;
  let arMin = config.enumMinPositionNos[config.enumPosition.ar]; // = 2;
  wkMin = wkMin - jWkCount;
  if (jSkill === config.enumPosition.wk) {
    wkMin = wkMin - 1;
  }
  wkMin = wkMin < 0 ? 0 : wkMin;
  batMin = batMin - jBtCount;
  if (jSkill === config.enumPosition.bat) {
    batMin = batMin - 1;
  }
  batMin = batMin < 0 ? 0 : batMin;
  bowlMin = bowlMin - jBlCount;
  if (jSkill === config.enumPosition.bowl) {
    bowlMin = bowlMin - 1;
  }
  bowlMin = bowlMin < 0 ? 0 : bowlMin;
  arMin = arMin - jArCount;
  if (jSkill === config.enumPosition.ar) {
    arMin = arMin - 1;
  }
  arMin = arMin < 0 ? 0 : arMin;
  let jAvailableSkillPlace = wkMin + batMin + bowlMin + arMin;
  let jAvailableSkillPlaceT = jAvailableSkillPlace;
  if (jSkill === config.enumPosition.wk) {
    jAvailableSkillPlaceT = batMin + bowlMin + arMin;
  } else if (jSkill === config.enumPosition.bat) {
    jAvailableSkillPlaceT = wkMin + bowlMin + arMin;
  } else if (jSkill === config.enumPosition.bowl) {
    jAvailableSkillPlaceT = wkMin + batMin + arMin;
  } else if (jSkill === config.enumPosition.ar) {
    jAvailableSkillPlaceT = wkMin + batMin + bowlMin;
  }
  if (jMaxTeamCountT > jAvailableSkillPlaceT) {
    for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
      let rowPlayer = arrSelectedPlayer[j];
      if (
        rowPlayer.Id === config.emptyValue &&
        rowPlayer.defaultSkillId === jSkill
      ) {
        rowPlayer.Id = jPlayerId;
        rowPlayer.SkillId = jSkill;
        if (isCaptain) {
          rowPlayer.isCaptain = isCaptain;
        } else if (isViceCaptain) {
          rowPlayer.isViceCaptain = isViceCaptain;
        }
        flag = true;
        break;
      }
    }
    if (!flag) {
      for (let j = 0; j < (arrSelectedPlayer || []).length; j++) {
        let rowPlayer = arrSelectedPlayer[j];
        if (
          rowPlayer.Id ===
          config.emptyValue /*  && rowPlayer.defaultSkillId === config.enumPosition.ar */
        ) {
          rowPlayer.Id = jPlayerId;
          rowPlayer.SkillId = jSkill;
          if (isCaptain) {
            rowPlayer.isCaptain = isCaptain;
          } else if (isViceCaptain) {
            rowPlayer.isViceCaptain = isViceCaptain;
          }
          flag = true;
          break;
        }
      }
    }
  }
  return {
    flag: flag,
    arrSelectedPlayer: arrSelectedPlayer,
  };
};
app.switchExistingFormation = (
  objPlayer,
  jSkillP,
  arrSelectedPlayer,
  players,
  jMaxTeamCount,
  isIgnore
) => {
  let objReturn = {
    retVal: config.enumSwitchType.none,
  };
  const SecondarySkillId =
    jSkillP === Number(objPlayer.SkillId)
      ? Number(objPlayer.SecondarySkillId)
      : Number(objPlayer.SkillId);
  const jPlayerId = Number(objPlayer.Id);
  let hasSecSkill = config.enumMaxPositionNos[SecondarySkillId];
  let flag = false;
  let jSkill = jSkillP;
  let jSkillMaxLength = config.enumMaxPositionNos[jSkill]
    ? config.enumMaxPositionNos[jSkill]
    : 0;
  let objMaxMinValidation = app.getMaxMinValidation(
    arrSelectedPlayer,
    jSkill,
    jSkillMaxLength,
    jMaxTeamCount
  );
  if (objMaxMinValidation.retVal === config.enumMinMaxType.max) {
  } else if (objMaxMinValidation.retVal === config.enumMinMaxType.min) {
  } else {
    //add
    const objSelectionAdded = app.addInTeamSelection(
      arrSelectedPlayer,
      jPlayerId,
      jSkill,
      jMaxTeamCount
    );
    flag = objSelectionAdded.flag;
    arrSelectedPlayer = objSelectionAdded.arrSelectedPlayer;
    objReturn = {
      retVal: config.enumSwitchType.changeSource,
      arrSelectedPlayer: arrSelectedPlayer,
      flag: flag,
    };
  }

  return objReturn;
};
app.getSkillShortNameBySillId = (arrSkillFiltreTab, SkillId) => {
  let objSkillFiltreTab = null;
  let SkillShortName = "";
  for (let j = 0; j < (arrSkillFiltreTab || []).length; j++) {
    const rowObj = arrSkillFiltreTab[j];
    if (rowObj.SkillId === SkillId) {
      SkillShortName = rowObj.SkillShortName;
      break;
    }
  }
  return SkillShortName;
};
app.converToCurrencyFormat = (number) => {
  if (number) {
    var integer = Number(number);
    var num = integer.toString();
    var decimalArr = num.split("."); // for decimal
    var numArr = decimalArr[0].split("");
    var count = 0;
    var newArr = [];
    for (var i = numArr.length - 1; i >= 0; i--) {
      newArr.unshift(numArr[i]);
      if (count % 2 == 0 && !(count == 0 || count == numArr.length - 1)) {
        newArr.unshift(",");
      }
      count++;
    }
    return newArr.join("") + (decimalArr[1] ? "." + decimalArr[1] : "");
  }
  return number;
};

app.getFilteredContestPlayer = (arrFiltresTab, players) => {
  let arrFilteredPlayer = [];

  if (players) {
    arrFiltresTab.map((data) => {
      const { arrDetails } = data;
      return arrDetails.map((team) => {
        if (team.tempChecked || team.checked) {
          for (let i = 0; i < players.length; i++) {
            let filterTeamId = team.id;
            let playerTeamId = players[i].teamid;
            if (filterTeamId == playerTeamId) {
              arrFilteredPlayer.push(players[i]);
            }
          }
        }
      });
    });
    arrFilteredPlayer.sort((a, b) => b.ovrpoint - a.ovrpoint);
  }

  return { arrFilteredPlayer: arrFilteredPlayer };
};
app.getFilteredContestPoints = (arrFiltresTab, points) => {
  let arrFilteredPoints = [];

  if (points) {
    arrFiltresTab.map((data) => {
      const { arrDetails } = data;
      return arrDetails.map((team) => {
        if (team.tempChecked || team.checked) {
          for (let i = 0; i < points.length; i++) {
            let filterTeamId = team.id;
            let playerTeamId = points[i].TeamId;
            if (filterTeamId == playerTeamId) {
              arrFilteredPoints.push(points[i]);
            }
          }
        }
      });
    });
    arrFilteredPoints.sort((a, b) => b.OverallPoints - a.OverallPoints);
  }

  return { arrFilteredPoints: arrFilteredPoints };
};

app.isValidValue = (val) => {
  let res = false;
  if (val !== undefined && val !== null && val !== "") {
    res = true;
  }
  return res;
};
app.processLeaderboardData = (oldData, newData) => {
  let mergedData = oldData;
  if (newData && newData.length) {
    mergedData = concat(oldData, newData);
  }
  return mergedData;
};
app.processUserRankDataManipulation = (leagueObj) => {
  const objCookie = app.getLoginCookie();
  let obj = {
    rno: 0,
    temid: leagueObj.temid ? leagueObj.temid : 0,
    temname: "",
    usrname: objCookie && objCookie.UserName ? objCookie.UserName : "",
    usrscoid: objCookie && objCookie.SocialId ? objCookie.SocialId : "",
    usrclnid: 1,
    rank: leagueObj.ovrank,
    points: leagueObj.ovpts,
    ftgdid: leagueObj.ftgdid ? leagueObj.ftgdid : 0,
    prfimg: objCookie && objCookie.ProfileURL ? objCookie.ProfileURL : "",
  };
  return obj;
};
app.getTotalPointsOfTeam = (
  arrPlayers,
  arrUserTeam,
  jCaptain,
  jViceCaptain
) => {
  let jTotal = 0;

  for (let j = 0; j < (arrUserTeam || []).length; j++) {
    let jId = arrUserTeam[j];
    let isCaptain = false;
    let isViceCaptain = false;
    const objMain = app.getPlayerDetails(arrPlayers, jId, []);
    if (objMain) {
      if (objMain.Id === jCaptain) {
        isCaptain = true;
      } else if (jViceCaptain === objMain.Id) {
        isViceCaptain = true;
      }
      let jPoints = 0;
      if (objMain.IsAnnounced === "P") {
        jPoints = Number(objMain.GamedayPoints);
        if (isCaptain) {
          jPoints = config.enumBonus.captain * Number(objMain.GamedayPoints);
        } else if (isViceCaptain) {
          jPoints =
            config.enumBonus.viceCaptain * Number(objMain.GamedayPoints);
        }
        jTotal = jTotal + jPoints;
      }
    }
  }
  jTotal = Number(jTotal).toFixed(1);
  jTotal = jTotal ? Number(jTotal) : jTotal;
  return { jTotal };
};

app.getMatchdays = (arrRound, hasTeam, isFreez, renderType, TeamGamedayId) => {
  let cookie = app.getLoginCookie();
  let jFixture = -1;
  let arrFilteredFixure = [];
  let fBreak = false;
  let fIsPointCalculationDone = app.isPointCalDone(arrRound);
  let isLockedAny = false;

  for (let jN = 0; jN < (arrRound || []).length; jN++) {
    let row = arrRound[jN];
    let rowFixture = row;
    let isIndexOfMatchdayId =
      hasTeam && hasTeam <= Number(rowFixture.TeamGamedayId);
    let jStatus = app.getFixtureStatusByRow(rowFixture);
    if (cookie && isIndexOfMatchdayId) {
      if (
        fIsPointCalculationDone &&
        (renderType === config.enumTeamRenderType.contest ||
          renderType === config.enumTeamRenderType.leaderboard)
      ) {
        if (jStatus !== config.enumFixtureType.isUpcomming) {
          arrFilteredFixure.push({ ...rowFixture });
          fBreak = true;
          jFixture = arrFilteredFixure.length - 1;
        }
      } else if (jStatus !== config.enumFixtureType.isUpcomming) {
        arrFilteredFixure.push({ ...rowFixture });
        fBreak = true;
        jFixture = arrFilteredFixure.length - 1;
      }

      if (
        jStatus !== config.enumFixtureType.isUpcomming &&
        jStatus !== config.enumFixtureType.isOpen
      ) {
        isLockedAny = true;
      }
    }
  }
  if (
    renderType === config.enumTeamRenderType.contest ||
    renderType === config.enumTeamRenderType.leaderboard
  ) {
    if (isLockedAny) {
      let arrRoundT = [];
      for (let j = 0; j < (arrFilteredFixure || []).length; j++) {
        const objRow = arrFilteredFixure[j];
        let jStatus = app.getFixtureStatusByRow(objRow);
        if (jStatus !== config.enumFixtureType.isOpen) {
          arrRoundT.push({ ...objRow });
          jFixture = arrRoundT.length - 1;
        }
      }
      arrFilteredFixure = arrRoundT;
      if (renderType === config.enumTeamRenderType.leaderboard) {
        arrFilteredFixure.push({ isOverall: true });
      }
    }
  }

  if (TeamGamedayId) {
    for (let j = 0; j < arrFilteredFixure.length; j++) {
      let row = arrFilteredFixure[j];
      if (TeamGamedayId === +row.TeamGamedayId) {
        jFixture = j;
        break;
      }
    }
  }
  if (jFixture === -1) {
    for (let j = 0; j < arrFilteredFixure.length; j++) {
      let row = arrFilteredFixure[j];
      let jStatus = app.getFixtureStatusByRow(row);
      // if (jStatus === config.enumFixtureType.isFinished || jStatus === config.enumFixtureType.isLock || jStatus === config.enumFixtureType.isEnded || jStatus === config.enumFixtureType.isAbandoned || jStatus === config.enumFixtureType.isOpen) {
      if (jStatus !== config.enumFixtureType.isUpcomming) {
        jFixture = j;
        // jGameDayId = row.GamedayId;
        // jPhaseId = row.PhaseId;
        //break;
      }
    }
  }

  return { arrFilteredFixure: arrFilteredFixure, jFixture: jFixture };
};
app.isFixtureChanged = (
  arrFixtures,
  LiveFixture,
  AbandonedGameDayId,
  FreezeGamedayId
) => {
  let isSame = true;
  for (let j = 0; j < arrFixtures.length; j++) {
    const objRow = arrFixtures[j];
    const jMdStatus = app.getFixtureStatusByRow(objRow);
    if (LiveFixture && LiveFixture.length) {
      const objRowLive = LiveFixture[0];
      const jMdStatusLive = app.getFixtureStatusByRow(objRowLive);
      if (
        jMdStatus !== jMdStatusLive &&
        objRow.TeamGamedayId === objRowLive.TeamGamedayId
      ) {
        isSame = false;
        break;
      }
    }
    if (
      FreezeGamedayId &&
      Number(objRow.IsActiveForNewUser) === 0 &&
      FreezeGamedayId === objRow.TeamGamedayId
    ) {
      isSame = false;
      break;
    } else if (!FreezeGamedayId && Number(objRow.IsActiveForNewUser) === 1) {
      isSame = false;
      break;
    }
    if (
      AbandonedGameDayId &&
      jMdStatus !== config.enumFixtureType.isAbandoned &&
      AbandonedGameDayId === objRow.TeamGamedayId
    ) {
      isSame = false;
      break;
    }
    /* else if (
      !AbandonedGameDayId &&
      jMdStatus === config.enumFixtureType.isAbandoned
    ) {
      isSame = false;
      break;
    } */
  }
  return isSame;
};
app.getMatchNames = (arrFixtures, jId, isAbandoned, trans) => {
  let sNames = "";
  let sMatchday = "";
  let arrNames = [];
  if (jId) {
    loop1: for (let j = 0; j < (arrFixtures || []).length; j++) {
      let objRow = arrFixtures[j];
      if (objRow.TeamGamedayId === jId) {
        for (let jN = 0; jN < (objRow.arrDetails || []).length; jN++) {
          let ele = objRow.arrDetails[jN];
          let fStatus = app.getFixtureStatusByMatches(ele);
          if (
            (isAbandoned && fStatus == config.enumFixtureType.isAbandoned) ||
            !isAbandoned
          ) {
            arrNames.push(
              `${ele.HomeTeamId ? ele.HomeTeamShortName : ""} ${
                trans && trans.vs ? trans.vs : "vs"
              } ${ele.AwayTeamId ? ele.AwayTeamShortName : ""}`
            );
          }
        }
        sMatchday = objRow.Matchday;
        break loop1;
      }
    }
    if (arrNames.length) {
      sNames = (
        trans.homeAbandonedMatch1
          ? trans.homeAbandonedMatch1
          : "We're abandoning the {{match1}} match"
      ).replace("{{match1}}", arrNames[0]);
      if (arrNames.length > 1) {
        sNames = (
          trans.homeAbandonedMatch2
            ? trans.homeAbandonedMatch2
            : "We're abandoning the {{match1}} and {{match2}} matches"
        )
          .replace("{{match1}}", arrNames[0])
          .replace("{{match2}}", arrNames[1]);
      }
    }
  }
  return {
    sMatchday: sMatchday,
    sNames: sNames,
  };
};
app.setErrorCode = (jStatusCode) => {
  let jErrorcode = config.enumErrorCode.normal;
  const arrToast = [403, 401, -999];
  const arrRedirect = [500, 400];
  if (arrToast.indexOf(jStatusCode) > -1) {
    jErrorcode = config.enumErrorCode.isToast;
  } else if (arrRedirect.indexOf(jStatusCode) > -1) {
    jErrorcode = config.enumErrorCode.isRedirect;
  }
  return jErrorcode;
};
export default app;
